

                if (!window.beaePageJS) {
                    window.beaePageJS = [];
                }
                let jsHandle_qnt4upfxlc = () => {
                    
                        if (document.querySelector('.beae-ica7f6yz:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let i=window.innerWidth,_=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=i&&(i=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>_(),500)};_()}).call({
                                $el: document.querySelector('.beae-ica7f6yz:not([data-beae-bind])'),
                                
                                id: 'beae-ica7f6yz',
                                isLive: true
                            });
                            document.querySelector('.beae-ica7f6yz:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-3qq82swv:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let i=window.innerWidth,_=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=i&&(i=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>_(),500)};_()}).call({
                                $el: document.querySelector('.beae-3qq82swv:not([data-beae-bind])'),
                                
                                id: 'beae-3qq82swv',
                                isLive: true
                            });
                            document.querySelector('.beae-3qq82swv:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-0t5yt8t8:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let i=window.innerWidth,_=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=i&&(i=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>_(),500)};_()}).call({
                                $el: document.querySelector('.beae-0t5yt8t8:not([data-beae-bind])'),
                                
                                id: 'beae-0t5yt8t8',
                                isLive: true
                            });
                            document.querySelector('.beae-0t5yt8t8:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-ablew95h:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let i=window.innerWidth,_=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=i&&(i=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>_(),500)};_()}).call({
                                $el: document.querySelector('.beae-ablew95h:not([data-beae-bind])'),
                                
                                id: 'beae-ablew95h',
                                isLive: true
                            });
                            document.querySelector('.beae-ablew95h:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-4fts20l8:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let i=window.innerWidth,_=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=i&&(i=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>_(),500)};_()}).call({
                                $el: document.querySelector('.beae-4fts20l8:not([data-beae-bind])'),
                                
                                id: 'beae-4fts20l8',
                                isLive: true
                            });
                            document.querySelector('.beae-4fts20l8:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-4uebqi4q:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let i=window.innerWidth,_=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=i&&(i=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>_(),500)};_()}).call({
                                $el: document.querySelector('.beae-4uebqi4q:not([data-beae-bind])'),
                                
                                id: 'beae-4uebqi4q',
                                isLive: true
                            });
                            document.querySelector('.beae-4uebqi4q:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                }
                if (window.beaejQuery) {
                    jsHandle_qnt4upfxlc()
                } else {
                    window.beaePageJS.push(jsHandle_qnt4upfxlc)
                }
            